// extracted by mini-css-extract-plugin
export default {"message":"ErrorBanner_message__TDk6K"};